<template>
  <div id="app">
    <h-header v-if="!hideLogo" />
      <h-error-boundary>
        <h-layout>
          <router-view v-if="initState === true" />
          <h-error v-else-if="initState === false" status="Init fail" :message="failMsg" />
          <div v-else style="padding: 50px">
            App is initializing...
          </div>
        </h-layout>
      </h-error-boundary>
    <h-footer v-if="!hideLogo" />
  </div>
</template>
<script>
import HHeader from '@/components/layout/HHeader.vue'
import HLayout from '@/components/layout/HLayout.vue'
import HFooter from '@/components/layout/HFooter.vue'
import HErrorBoundary from '@/components/base/HErrorBoundary.vue'
import HError from '@/components/base/HError.vue'
import { h365PlatformApi, clientLocationApi } from '@/plugin/axios'

export default {
  name: 'AppRoot',
  components: {
    HHeader,
    HLayout,
    HFooter,
    HErrorBoundary,
    HError
  },
  data() {
    return {
      initState: null,
      failMsg: ''
    }
  },
  computed: {
    hideLogo() {
      return this.$store.state.hideLogo
    }
  },
  created() {
    // eslint-disable-next-line no-unused-vars
    this.$router.onReady((currentRoute) => {
      this.init()
    }, (err) => {
      console.log('route ready fail', err)
    })
  },
  methods: {
    async init() {
      try {
        this.initLanguage()
        await this.initSettingCookies()
        const token = await this.initToken()
        await this.initUser(token)
        await this.initClientLocation()
        this.initState = true
      }
      catch (e) {
        this.initState = false
        this.failMsg = e.message
      }
    },
    async initSettingCookies() {
      console.log('initSettingCookies', this.$route.query)
      // eslint-disable-next-line no-unused-vars
      const urlScheme = this.$route.query.url_scheme ?? this.$cookies.get('h365_applicationUrl')
      const urlHome = this.$route.query.url_home ?? this.$cookies.get('h365_urlHome')
      const hideLogo = this.$route.query.hideLogo ?? this.$cookies.get('h365_hideLogo')

      // applicationUrl
      if (urlScheme) {
        this.$cookies.set('h365_applicationUrl', urlScheme)
        this.$store.commit('setApplicationUrl', urlScheme)
      }

      // url home
      if (urlHome) {
        this.$cookies.set('h365_urlHome', urlHome)
        this.$store.commit('setUrlHome', urlHome)
      }
      // hide logo
      if (hideLogo) {
        this.$cookies.set('h365_hideLogo', hideLogo)
        this.$store.commit('setHideLogo', hideLogo)
      }
    },
    initLanguage() {
      const { language } = this.$route.query
      console.log('language', language)
      console.log('this', this.$route.query)
      if (this.$i18n.availableLocales.includes(language)) {
        console.log('set lang', language)
        this.$i18n.locale = language
      }
    },
    async initToken() {
      const token = this.$route.query.token ?? this.$cookies.get('h365')
      if (!token) throw Error(this.$t('error.USER_HEADER_ERROR'))
      this.$store.commit('setToken', token)
      return token
    },
    async initUser(token) {
      try {
        const { data: { data: user } } = await h365PlatformApi.get('/user', {
          headers: {
            Authorization: `Bearer ${token}`
          }
        })
        this.$store.commit('setUser', user)
        return
      }
      catch (e) {
        this.$store.commit('removeToken')
        throw Error(this.$t('error.TOKEN_VERIFY_FAILED'))
      }
    },
    async initClientLocation() {
      if (!this.$store.state?.clientLocation) {
        const { data } = await clientLocationApi()
        this.$store.commit('setClientLocation', data)
      }
    }
  }
}
</script>
